import { ContactFormData } from '../types';

// Clé de site reCAPTCHA v3
const RECAPTCHA_SITE_KEY = '6LftvDEsAAAAAPibrAdUUV-IFzQ_MrAK7Ud8SGnc';

// Déclaration pour TypeScript
declare global {
  interface Window {
    grecaptcha: {
      ready: (callback: () => void) => void;
      execute: (siteKey: string, options: { action: string }) => Promise<string>;
    };
  }
}

interface ContactFormDataWithExtras extends ContactFormData {
  website?: string;  // Honeypot field
  recaptchaToken?: string;
}

export const sendContactEmail = async (formData: ContactFormDataWithExtras): Promise<void> => {
  try {
    // Ne pas envoyer si le honeypot est rempli (bot détecté côté client)
    if (formData.website && formData.website.length > 0) {
      return;
    }

    // Obtenir le token reCAPTCHA
    let recaptchaToken = '';
    if (window.grecaptcha) {
      recaptchaToken = await new Promise((resolve) => {
        window.grecaptcha.ready(async () => {
          const token = await window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: 'contact_form' });
          resolve(token);
        });
      });
    }

    const response = await fetch('/api/send-email.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...formData,
        recaptchaToken
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Erreur lors de l\'envoi de l\'email');
    }

    const result = await response.json();
    if (!result.success) {
      throw new Error(result.error || 'Erreur lors de l\'envoi de l\'email');
    }
  } catch (error) {
    console.error('Erreur lors de l\'envoi de l\'email:', error);
    throw new Error('Impossible d\'envoyer le message. Veuillez réessayer.');
  }
};

// Fonction vide pour compatibilité
export const initEmailJS = () => {};
